import { axios } from '@/services/axios';

const getVoicePolicies = async () => {
    const res = await axios.get('/VoicePolicies/');
    return res.data;
};

export default getVoicePolicies;
